import { unref } from 'vue';

import { localAxios } from '../../apis';
import { reportError } from '@/utils/report-error';

export function useActivityLogger(endpoint) {
  async function log(type, data) {
    try {
      await localAxios.post(unref(endpoint), {
        type,
        data,
      });
    } catch (e) {
      reportError(e);
    }
  }

  return log;
}
